import React from "react";
import Card from "react-bootstrap/Card";

function ProjectCard({ title, description, imageUrl, projectUrl }) {
  return (
    <Card>
      <Card.Img variant="top" src={imageUrl} style={{ height: "250px", objectFit: "cover" }} />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{description}</Card.Text>
        <a href={projectUrl} target="_blank" rel="noopener noreferrer">
          Github
        </a>
      </Card.Body>
    </Card>
  );
}

export default ProjectCard;
